import { Button, Dialog, Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import CustomDialogTitle from '../../../projectsDashboard/CustomDialogTitle';
import BatchDetailsUnitBox from '../viewProcessInformation/BatchDetailsUnitBox';
import ExceptionDetails from '../viewBatchQualityEvents/ExceptionDetails';
import ViewStructuredInformation from '../ViewStructuredInformation';
import { useDispatch } from 'react-redux';
import { fetchDSBatchDetails } from '../../../../../containers/actions/common/saslAction';
import ViewRmPMLots from './../ViewRMPMLots/index'

export const ViewBatchPageButtons = (props) => {
  const dispatch = useDispatch()

  const { batchDetails, view, schrockenDeliveryScheduleID, featureAccess, targetQuantity, cmoBatchNumber,consumptionSameAsAllocation } = props
 

  
  const [openDialogBox, setDialogBox] = useState({
    viewProcessInformation: false,
    viewQualityEvents: false,
    viewStructuredInformation: false,
    viewRMPMLots: false,
  })

  const handleOpenCloseDialogBox = (type) => {
    if (type === 'viewProcessInformation') {
      setDialogBox({
        viewProcessInformation: !openDialogBox.viewProcessInformation,
        viewQualityEvents: false,
        viewStructuredInformation: false,
      })
    } else if (type === 'viewQualityEvents') {
      setDialogBox({
        viewProcessInformation: false,
        viewQualityEvents: !openDialogBox.viewQualityEvents,
        viewStructuredInformation: false,
      })
    } else if (type === 'viewStructuredInformation') {
      setDialogBox({
        viewProcessInformation: false,
        viewQualityEvents: false,
        viewStructuredInformation: !openDialogBox.viewStructuredInformation,
      })
      if (openDialogBox.viewStructuredInformation) {
        let data1 = {
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          //cmoBatchNumber: cmoBatchNumber,
        };
        dispatch(fetchDSBatchDetails(data1));
      }

    } else if (type === 'viewRMPMLots') {
      setDialogBox({
        ...openDialogBox,
        viewRMPMLots: !openDialogBox.viewRMPMLots,
      })
      if (openDialogBox.viewRMPMLots) {
        let data1 = {
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          //cmoBatchNumber: cmoBatchNumber,
        };
        dispatch(fetchDSBatchDetails(data1));
      }
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        {/* {featureAccess?.fgBatchViewProcessInformation &&
        <Grid item>
          <Button style={{textTransform:'none'}} variant="contained" color="secondary" onClick={()=>handleOpenCloseDialogBox('viewProcessInformation')}>
            View process information
          </Button>
        </Grid>
        } */}

        {/* {featureAccess?.fgBatchViewQualityEvents &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewQualityEvents')}>
              View quality events
            </Button>
          </Grid>
        } */}

        {featureAccess?.fgBatchViewDigitizedInformation &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewStructuredInformation')}>
              View Digitalized Information
            </Button>
          </Grid>
        }

        {featureAccess?.viewGoodsReceipt &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewRMPMLots')}>
              {/* View RM/PM lots (Planned and actual) */}
              View Goods Receipt and Consumption Validation
            </Button>
          </Grid>
        }

      </Grid>
      <Dialog open={openDialogBox.viewProcessInformation} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewProcessInformation')}
          title={'View process information'}
        />
        <BatchDetailsUnitBox batchDetails={batchDetails} view={view} featureAccess={featureAccess} />
      </Dialog>


      <Dialog open={openDialogBox.viewQualityEvents} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewQualityEvents')}
          title={'View quality events'}
        />
        <ExceptionDetails batchDetails={batchDetails} featureAccess={featureAccess} />
      </Dialog>

      <Dialog open={openDialogBox.viewStructuredInformation} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewStructuredInformation')}
          title={'View Digitalized Information'}
        />
        <ViewStructuredInformation
          batchDetails={batchDetails}
          schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
          cmoBatchNumber={cmoBatchNumber}
          featureAccess={featureAccess}
          targetQuantity={targetQuantity}
          consumptionSameAsAllocation={consumptionSameAsAllocation}
        />
      </Dialog>

      <Dialog open={openDialogBox.viewRMPMLots} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewRMPMLots')}
          // title={'View RM/PM lots (Planned and actual)'}
          title={'View Consumption'}
        />
        <ViewRmPMLots batchDetails={batchDetails}
          selectedDeliveryBatchID={batchDetails?.schrockenDeliveryScheduleBatchID}
          targetQuantity={targetQuantity}
          cmoBatchNumber={cmoBatchNumber}
          onDataRefresh={() => {
            let data1 = {
              schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
              //cmoBatchNumber: cmoBatchNumber,
            };
            dispatch(fetchDSBatchDetails(data1));
          }}
        />
      </Dialog>

    </React.Fragment>
  );
};
